import { useState, useEffect } from 'react';
import API from '../api/axios';
import Modal from '../components/Modal';
import { useToast } from '../context/ToastContext';
import { Icon } from '../components/SvgIcons';

const Moderators = () => {
  const [moderators, setModerators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalConfig, setModalConfig] = useState({ isOpen: false });
  const { showToast } = useToast();

  useEffect(() => {
    fetchModerators();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchModerators = async () => {
    try {
      setLoading(true);
      const moderatorsRes = await API.get('/admins');
      setModerators(moderatorsRes.data.admins || []);
    } catch (err) {
      console.error('Failed to fetch moderators:', err);
      showToast('Failed to load moderators', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (userId, newStatus, moderatorName) => {
    setModalConfig({
      isOpen: true,
      type: newStatus === 'active' ? 'success' : 'warning',
      title: newStatus === 'active' ? 'Activate Moderator' : 'Deactivate Moderator',
      message: `Are you sure you want to ${newStatus === 'active' ? 'activate' : 'deactivate'} ${moderatorName}?`,
      confirmText: newStatus === 'active' ? 'Activate' : 'Deactivate',
      onConfirm: () => confirmStatusChange(userId, newStatus)
    });
  };

  const confirmStatusChange = async (userId, newStatus) => {
    try {
      await API.put(`/admins/${userId}/status`, { status: newStatus });
      showToast(`Moderator ${newStatus === 'active' ? 'activated' : 'deactivated'} successfully`, 'success');
      fetchModerators();
    } catch (err) {
      showToast(err.response?.data?.message || 'Failed to update status', 'error');
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div>
          <h1 className="dashboard-title" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}><Icon name="Users" size={22} /> Moderators Management</h1>
          <p className="dashboard-subtitle" style={{ color: 'white' }}>Manage all moderators in the system</p>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Moderators</div>
          <div className="stat-value">{moderators.length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Active</div>
          <div className="stat-value">
            {moderators.filter(m => m.status === 'active').length}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Inactive</div>
          <div className="stat-value">
            {moderators.filter(m => m.status === 'inactive').length}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 style={{ margin: 0, fontSize: '1rem' }}>All Moderators ({moderators.length})</h2>
        </div>

        <div>
            {moderators.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state-icon"><Icon name="Users" size={40} /></div>
                <p>No moderators found</p>
              </div>
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>College</th>
                    <th>University</th>
                    <th>Status</th>
                    <th>Joined</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {moderators.map(moderator => (
                    <tr key={moderator.user_id}>
                      <td><strong>{moderator.name}</strong></td>
                      <td>{moderator.email}</td>
                      <td>{moderator.college_name}</td>
                      <td>{moderator.university_name}</td>
                      <td>
                        <span className={`badge badge-${moderator.status === 'active' ? 'success' : 'danger'}`}>
                          {moderator.status}
                        </span>
                      </td>
                      <td>{new Date(moderator.created_at).toLocaleDateString()}</td>
                      <td>
                        <div className="btn-group">
                          {moderator.status === 'active' ? (
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleStatusChange(moderator.user_id, 'inactive', moderator.name)}
                            >
                              Deactivate
                            </button>
                          ) : (
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => handleStatusChange(moderator.user_id, 'active', moderator.name)}
                            >
                              Activate
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
      </div>

      {/* Modal */}
      <Modal
  key={modalConfig.title + modalConfig.message} // Forces remount when text changes
  isOpen={modalConfig.isOpen}
  onClose={() => setModalConfig({ isOpen: false })}
  onConfirm={modalConfig.onConfirm}
  title={modalConfig.title}
  message={modalConfig.message}
  type={modalConfig.type}
  confirmText={modalConfig.confirmText}
  cancelText={modalConfig.cancelText || 'Cancel'}
/>


    </div>
  );
};

export default Moderators;
